/* 19 Oct 2026: adds the edge-peek artwork to the Giffy buddy (styles in gh-buddy-peek.css).
   Image URLs come from window.ghBuddyPeek, set in sections/gh-ai-chat.liquid. */
(function () {
  if (window.ghBuddyPeekInit) return;
  window.ghBuddyPeekInit = true;
  var src = window.ghBuddyPeek || {};
  if (!src.right || !src.left) return;
  var SIZE = { right: [65, 88], left: [70, 88] };

  function add(wrap) {
    var btn = wrap.querySelector('.gh-buddy__btn');
    if (!btn || btn.querySelector('.gh-buddy__peek')) return;
    ['right', 'left'].forEach(function (side) {
      var img = document.createElement('img');
      img.className = 'gh-buddy__peek gh-buddy__peek--' + side;
      img.src = src[side];
      img.alt = '';
      img.width = SIZE[side][0];
      img.height = SIZE[side][1];
      img.draggable = false;
      img.setAttribute('aria-hidden', 'true');
      btn.appendChild(img);
    });
    wrap.classList.add('has-peek');
  }

  function scan(root) {
    if (root.matches && root.matches('.gh-buddy')) add(root);
    else if (root.querySelectorAll) root.querySelectorAll('.gh-buddy').forEach(add);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan(document);
})();
